export const isEmpty = (value: unknown) => {
  return value === '' || value === null || value === undefined;
};

export const parseParam = <T>(p: any): T => JSON.parse(p);
export const convertParam = <T>(p: T) => (!isEmpty(p) ? JSON.stringify(p) : '');
